export default __webpack_public_path__ + "static/media/Chhatt_book_m.8f6f8c45.wav";